<script>
import Editor from '@/components/texteditor/html/HtmlEditor';
import FormTextEditor from './FormTextEditor';

/**
 * FormTextEditor Component
 *
 * Include BasicEditor Component
 *
 * @property {String}   value      Text Editor content (Plain HTML)
 * @property {String}   type       Change Text Editor type
 * @property {Object}   [options]  Add more options to the Text Editor
 * @property {String}   hint       Change the default Text Editor placeholder
 * @property {Boolean}  disabled   Disable Text Editor
 * @property {Number}   limit      Text Editor letters limit
 * @property {Boolean}  counter    Show characters counter
 *
 * @fires FormTextEditor#blur      Emit String of HTML
 * @fires FormTextEditor#input     Emit String of HTML
 */

export default {
  name: 'nx-form-html-editor',
  extends: FormTextEditor,
  data() {
    return {
      editorComponent: Editor.name,
    };
  },
  components: {
    [Editor.name]: Editor,
  },
};
</script>
